exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".u-inputNumber[data-v-f5fdf204]{width:100%}.u-inputNumber.is-disabled[data-v-f5fdf204] .el-input__inner{background-color:#f7f7f7;border-color:#e1e4ea}.u-inputNumber.isView[data-v-f5fdf204] .el-input__inner{background-color:#f7f7f7}.u-inputNumber[data-v-f5fdf204] .el-input__inner{text-align:left}\n", ""]);

// exports
